export default __webpack_public_path__ + "static/media/carback.92677787.jpg";